// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Modal_modalOverlay__sPh1m","modalContent":"Modal_modalContent__8s-Es","closeButton":"Modal_closeButton__uqAwN","modalMessage":"Modal_modalMessage__7BIcI"};